import { useState } from "react";
import axios from "axios";

const CopyrightSection = () => {
  const [formData, setFormData] = useState({
    title: "",
    author: "",
    registrationNumber: "",
    year: "",
    department: "",
    description: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        "https://admin.stipsredu.in/copyright/add",
        formData
      );

      alert("Copyright added successfully!");

      setFormData({
        title: "",
        author: "",
        registrationNumber: "",
        year: "",
        department: "",
        description: ""
      });

    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "Error adding copyright");
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Add Copyright</h2>

      <form onSubmit={handleSubmit} className="space-y-4 bg-white p-6 rounded-xl shadow-md">
        
        <input
          type="text"
          name="title"
          placeholder="Title"
          value={formData.title}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="text"
          name="author"
          placeholder="Author"
          value={formData.author}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="text"
          name="registrationNumber"
          placeholder="Registration Number"
          value={formData.registrationNumber}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="number"
          name="year"
          placeholder="Year"
          value={formData.year}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="text"
          name="department"
          placeholder="Department"
          value={formData.department}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <button
          type="submit"
          className="bg-purple-600 text-white px-6 py-2 rounded-lg"
        >
          Add Copyright
        </button>
      </form>
    </div>
  );
};

export default CopyrightSection;